import React, { useState } from "react";
import { propertyFaviconSrc } from "../utils/property-favicon";

type Props = {
  propertyUrl?: string;
  size?: number;
  className?: string;
};

const PropertyFavicon: React.FC<Props> = ({
  propertyUrl,
  size = 16,
  className = "",
}) => {
  const [failed, setFailed] = useState(false);
  const src = propertyFaviconSrc(propertyUrl, size);

  if (!src || failed) {
    return (
      <span
        aria-hidden="true"
        className={`inline-block flex-shrink-0 rounded-sm bg-gray-200 ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      className={`inline-block flex-shrink-0 rounded-sm ${className}`}
      onError={() => setFailed(true)}
    />
  );
};

export { PropertyFavicon };
